import { configureStore } from "@reduxjs/toolkit";
import React from "react";
import { TypedUseSelectorHook, createDispatchHook, createSelectorHook } from "react-redux";
import failoverSlice from "./failoverSlice";

export const FailoverContext = React.createContext(null);

const failoverStore = configureStore({
    reducer: {
        failoverStore: failoverSlice,
    },
});
export default failoverStore;

export type State = ReturnType<typeof failoverStore.getState>;
export type Dispatch = typeof failoverStore.dispatch;
export const useFailoverSelector: TypedUseSelectorHook<State> = createSelectorHook(FailoverContext);
export const useFailoverDispatch = createDispatchHook<Dispatch>(FailoverContext);
